import { render, staticRenderFns } from "./Customstatistics.vue?vue&type=template&id=da1b83d4&scoped=true&"
import script from "./Customstatistics.vue?vue&type=script&lang=js&"
export * from "./Customstatistics.vue?vue&type=script&lang=js&"
import style0 from "./Customstatistics.vue?vue&type=style&index=0&id=da1b83d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da1b83d4",
  null
  
)

export default component.exports